import React, { useLayoutEffect } from 'react';
import { Button, Typography } from '@mui/material';

const MatrixRedirect = (): React.ReactElement => {
  const close = () => {
    window.close();
  };

  useLayoutEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const loginToken = urlParams.get('loginToken');

    const sendTokenMessage = () => {
      if (window.opener && loginToken) {
        window.opener.postMessage(
          { type: 'loginToken', token: loginToken },
          window.location.origin
        );
        setTimeout(window.close, 5000);
      } else if (window.parent && loginToken) {
        window.parent.postMessage(
          { type: 'loginToken', token: loginToken },
          window.location.origin
        );
      } else {
        console.info('You can close this window');
      }
    };

    setTimeout(sendTokenMessage, 3000);
  }, []);

  return (
    <div>
      <Typography variant="h5" component="h2">
        You can close this window
      </Typography>
      <Button variant="contained" onClick={close}>
        Close
      </Button>
    </div>
  );
};

export default MatrixRedirect;
